module.exports = __webpack_public_path__ + "files/409bcea2f72cee93f98ddfb4e2a37140.svg";